/*
* @TagDialog.vue.vue  uwb基站配置
* @Description
* @Author zhangbin
* @Date 2021/6/28
*/
/* HTML */
<template>
    <el-dialog :title="dialogForm.title"
               :visible.sync="dialogForm.dialogFormVisible"
               :close-on-click-modal="false"
               custom-class="form-dialog"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >
        <el-form label-width="120px" ref="rowForm" :rules="rules" :model="rowForm">
            <el-form-item label="标签前4位：" prop="prefix4">
                <el-input v-model="rowForm.prefix4" clearable @input="changePrefix4" title="请输入长度为4的十六进制数" maxlength="4" show-word-limit />
            </el-form-item>
            <el-form-item label="产品型号：" prop="mode">
                <el-input v-model="rowForm.mode" clearable @input="changeMode" title="请输入长度为2的十六进制数" maxlength="2" show-word-limit />
            </el-form-item>
            <el-form-item label="生产批次：" prop="batch">
                <el-input v-model="rowForm.batch" clearable @input="changeBatch" title="请输入长度为2的十六进制数" maxlength="2" show-word-limit />
            </el-form-item>
            <el-form-item label="客户编号：" prop="customer">
                <el-input v-model="rowForm.customer" clearable @input="changeCustomer" title="请输入长度为4的十六进制数" maxlength="4" show-word-limit />
            </el-form-item>
            <el-form-item label="起始号：" prop="startId">
                <el-input v-model="rowForm.startId" clearable @input="changeStartId" maxlength="4" show-word-limit />
            </el-form-item>
            <el-form-item label="结束号：" prop="endId">
                <el-input v-model="rowForm.endId" clearable  @input="changeEndId" maxlength="4" show-word-limit />
            </el-form-item>
            <el-form-item label="选择项目：" v-if="false" prop="projectId">
                <el-select v-model="rowForm.projectId" placeholder="请选择项目" clearable>
                    <el-option v-for="(value,key) in projectInfos" :key="key" :label="value.projectName" :value="key" ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="btn-form-item-c" >
                <el-button type="primary" size="mini" @click.native="save">保存号段</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

/* JS */
<script>

    // API oam
	import ApiOam from '@/request/api-oam'
    import {checkHexChar} from '@/global/global-valid'

    export default {
        /**
         * @Des 组件名
         * @Auth jsh
         * @Date 10:21 2021/6/28
         */
        name: "UwbTagIdAddDialog",
        /**
         * @Des 组件引用
         * @Auth jsh
         * @Date 2021/7/1
         */
        components: {
        },
        props:{
            projectInfos: Object
        },
        /**
         * @Des 数据定义
         * @Auth jsh
         * @Date 08:46 2021/6/29
         */
        data() {
          return {
              // 弹出层属性
              dialogForm: {
                  title: "",
                  dialogFormVisible: false,
              },
              /**
               * @Des 标签属性
               * @Auth jsh
               * @Date 14:39 2021/6/28
               */
              rowForm: {
                  prefix4: "8801",   // 前四位
                  mode: "",         // 产品型号：2位
                  batch: "",        // 生产批次：2位
                  customer: "",     // 客户编号：4位
                  startId: "",      // 起始号
                  endId: "",        // 结束号
                  projectId: this.$store.state.currentProjectId,
              },
              /**
               * @Des 规则属性
               * @Auth jsh
               * @Date 14:39 2021/6/28
               */
              rules: {
                  changePrefix4: [
                      { required: true, message: '标签前4位不能为空', trigger: 'blur' },
                      {
                          validator: (rule, value, callback) => {
                              this.rowForm.prefix4 = value.toLocaleUpperCase();
                              if(this.rowForm.prefix4.length < 12){
                                  new callback(new Error("标签不足4位"))
                              } else{
                                  callback()
                              }
                          },
                          trigger: "blur",
                      },
                  ],
                  mode: [
                      {required: true, message: '请输入产品型号', trigger: 'blur'}
                  ],
                  batch: [
                      {required: true, message: '请输入生产批次', trigger: 'blur'}
                  ],
                  customer: [
                      {required: true, message: '请输入客户编号', trigger: 'blur'}
                  ],
                  startId: [
                      {required: true, message: '请选择起始号', trigger: 'blur'}
                  ],
                  endId: [
                      {required: true, message: '请选择结束号', trigger: 'blur'}
                  ],
              },
          }
        },
        created(){
        },
        mounted() {
        },
        /**
         * @Des 方法定义
         * @Auth jsh
         * @Date 10:21 2021/6/28
         */
        methods: {
            /**
             * @Author ZhangBin
             * @Description //TODO 改变16进制数
             * @Date 11:29 2022/5/13
             * @Param
             * @return
             **/
            changePrefix4(v){
                if(!checkHexChar(v) || v.length > 12){
                    this.rowForm.prefix4 = v.substring(0, v.length-1);
                    while (!checkHexChar(this.rowForm.prefix4)){
                        if(this.rowForm.prefix4 == ''){
                            break;
                        }
                        this.rowForm.prefix4 = this.rowForm.prefix4.substring(0, this.rowForm.prefix4.length-1);
                    }
                    return;
                }
                this.rowForm.prefix4 = this.rowForm.prefix4.toUpperCase();
            },
            /**
             * @Author ZhangBin
             * @Description //TODO 改变产品型号
             * @Date 11:29 2022/5/13
             * @Param
             * @return
             **/
            changeMode(v){
                if(!checkHexChar(v) || v.length > 12){
                    this.rowForm.mode = v.substring(0, v.length-1);
                    while (!checkHexChar(this.rowForm.mode)){
                        if(this.rowForm.mode == ''){
                            break;
                        }
                        this.rowForm.mode = this.rowForm.mode.substring(0, this.rowForm.mode.length-1);
                    }
                    return;
                }
                this.rowForm.mode = this.rowForm.mode.toUpperCase();
            },
            /**
             * @Author ZhangBin
             * @Description //TODO 改变生产批次
             * @Date 11:29 2022/5/13
             * @Param
             * @return
             **/
            changeBatch(v){
                if(!checkHexChar(v) || v.length > 12){
                    this.rowForm.batch = v.substring(0, v.length-1);
                    while (!checkHexChar(this.rowForm.batch)){
                        if(this.rowForm.batch == ''){
                            break;
                        }
                        this.rowForm.batch = this.rowForm.batch.substring(0, this.rowForm.batch.length-1);
                    }
                    return;
                }
                this.rowForm.batch = this.rowForm.batch.toUpperCase();
            },
            /**
             * @Author ZhangBin
             * @Description //TODO 改变客户编号
             * @Date 11:29 2022/5/13
             * @Param
             * @return
             **/
            changeCustomer(v){
                if(!checkHexChar(v) || v.length > 12){
                    this.rowForm.customer = v.substring(0, v.length-1);
                    while (!checkHexChar(this.rowForm.customer)){
                        if(this.rowForm.customer == ''){
                            break;
                        }
                        this.rowForm.customer = this.rowForm.customer.substring(0, this.rowForm.customer.length-1);
                    }
                    return;
                }
                this.rowForm.customer = this.rowForm.customer.toUpperCase();
            },

            /**
             * @Author ZhangBin
             * @Description //TODO 改变起始号
             * @Date 11:36 2022/5/13
             * @Param
             * @return
             **/
            changeStartId(v){
                // 16进制
                if(!checkHexChar(v) || v.length > 4){
                    this.rowForm.startId = v.substring(0, v.length-1);
                    while (!checkHexChar(this.rowForm.startId)){
                        if(this.rowForm.startId == ''){
                            break;
                        }
                        this.rowForm.startId = this.rowForm.startId.substring(0, this.rowForm.startId.length-1);
                    }
                    return;
                }
                this.rowForm.startId = this.rowForm.startId.toUpperCase();
            },

            /**
             * @Author ZhangBin
             * @Description //TODO 改变结束号
             * @Date 11:36 2022/5/13
             * @Param
             * @return
             **/
            changeEndId(v){
                // 16进制
                if(!checkHexChar(v) || v.length > 4){
                    this.rowForm.endId = v.substring(0, v.length-1);
                    while (!checkHexChar(this.rowForm.endId)){
                        if(this.rowForm.endId == ''){
                            break;
                        }
                        this.rowForm.endId = this.rowForm.endId.substring(0, this.rowForm.endId.length-1);
                    }
                    return;
                }
                this.rowForm.endId = this.rowForm.endId.toUpperCase();
            },

            /**
             * @Des 打开弹出层
             * @Auth jsh
             * @Date 09:46 2021/6/28
             */
            openDialog(title, data) {
                // console.log(data);
                this.dialogForm.title = title;
                this.dialogForm.dialogFormVisible = true;
                this.rowForm.prefix4 = '8801';
                this.rowForm.batch = '01';
                this.rowForm.customer = '0001';
            },

            /**
             * 保存编辑
             * */
            save(){
                // console.log(this.bsForm)
                this.$refs.rowForm.validate(valid => {
                    if(!valid) return false;
                    this.$request.postJsonRequest(ApiOam.Add_Uwb_Tag_Id_Batch_Uri, this.rowForm).then(result => {
                        // console.log(result)
                        if (result.code == 0) {
                            this.$message({
                                message: '保存成功',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            setTimeout(()=>{
                                this.$emit("research");
                                this.handleDialogClose();
                            },1000)
                        } else {
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        console.error('标签编号添加异常', ApiOam.Add_Uwb_Tag_Id_Uri, error);
                    })
                })
            },

            /**
             * @Des 弹窗关闭
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            handleDialogClose() {
                this.reset();
            },
            /**
             * @Des 重置
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            reset() {
                this.cleanValidate('rowForm');
                this.cleanData();
            },

            /**
             * @Des 清除表单验证
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            cleanValidate(formName) {
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
             * @Des 清除数据
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            cleanData() {
                this.dialogForm.dialogFormVisible = false;
                // 将数据置为空
                this.rowForm = Object.assign({}, {});
            },
        }
    }
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components_pages/Device/UwbTagIdAddDialog.vue